const firstRunInput = {
  heading: '新規分析',
  history: '分析履歴',
  basicInfo: '基本情報',
  itemName: '分析対象の部品名',
  itemNamePlaceholder: '例：ブレーキパッド、ECU基板',
  nulNotAllowed: 'NUL文字（U+0000）を削除してください',
  itemNameRequired: '部品名を入力してください',
  title: '分析タイトル',
  titlePlaceholder: '例：2024年モデル仕様変更分析',
  cadPlaceholder: 'CADモデルを選択してください',
  modeLabels: { old_new: '新・旧仕様の入力', difference: '差分仕様の入力' },
  cadHelp: '任意。この分析で参照するCADモデルです。',
  specifications: '仕様書',
  modeLabel: '入力する内容',
  modes: {
    old_new: '新・旧仕様の入力',
    difference: '差分仕様の入力',
  },
  sourceKinds: { text: '直接入力', document: '登録文書を参照', derived: '文書からの編集コピー' },
  editCopy: '抽出本文をコピーして編集',
  derivedHelp: '{{name}}（版 {{version}}）のコピーです。元の文書は変更されません。編集内容は未検証の候補として扱われます。',
  textHelp: '直接入力は未検証の候補として扱われます。入力元を切り替えても下書きは保持されます。',
  hiddenDraftKept: 'もう一方の入力内容は保持されますが、送信されません。',
  mixedInputUnsupported: '旧・新の両方に登録文書を選ぶか、両方にテキストを入力してください。登録文書とテキストの組み合わせは未対応です。入力内容は保持されています。',
  fields: {
    old: '旧仕様書',
    new: '新仕様書',
    difference: '旧仕様書と新仕様書の差分',
  },
  placeholders: {
    old: '旧仕様書の内容を入力',
    new: '新仕様書の内容を入力',
    difference: '旧仕様書と新仕様書の差分を入力',
  },
  required: {
    old: '旧仕様書を入力するか、登録文書を選択してください',
    new: '新仕様書を入力するか、登録文書を選択してください',
    difference: '差分を入力するか、登録文書を選択してください',
  },
  supplement: '補足情報',
  supplementPlaceholder: '文書にない条件・制約・背景など',
  supplementHelp: '任意。仕様書と一緒に分析へ渡します。',
  analysisInfo:
    'AIが仕様書を比較し、変更点を抽出して故障モード分析を行います。分析には数分かかる場合があります。',
  start: '分析開始',
  starting: '開始しています…',
};

export default firstRunInput;
